module.exports = __webpack_public_path__ + "img/501_yw.front.7695577e.jpg";